"use strict";

/**
 * WEB予約：入力フォーム → 確認モーダル → mail.php へ POST
 * - 必須（サーバ検証）: 住居区分 / 郵便番号 / お名前 / 電話番号 / お問い合わせ内容
 * - 任意: ガス利用開始希望日（hidden・未入力は空）
 * - お問い合わせの詳細: GAS 用など申込内容のまとめテキスト
 */

{
  const entryForm = document.getElementById("contactReserveForm");
  const confirmDialog = document.getElementById("contactMailConfirm");
  const phpForm = document.getElementById("contactPhpMailForm");

  if (!entryForm || !confirmDialog || !phpForm) {
    // LP 以外では要素が無い
  } else {
    const el = {
      residenceType: document.getElementById("contact-residence-type"),
      mansionType: document.getElementById("contact-mansion-type"),
      mansionTypeRow: document.getElementById("contact-mansion-type-row"),
      postcode: document.getElementById("contact-postcode"),
      name: document.getElementById("contact-name"),
      tel: document.getElementById("contact-tel"),
      email: document.getElementById("contact-email"),
      startDate: document.getElementById("contact-start-date"),
    };

    const view = {
      residenceType: document.getElementById("contactConfirmResidenceType"),
      mansionType: document.getElementById("contactConfirmMansionType"),
      mansionTypeRow: document.getElementById("contact-confirm-mansion-type-row"),
      postcode: document.getElementById("contactConfirmPostcode"),
      name: document.getElementById("contactConfirmName"),
      tel: document.getElementById("contactConfirmTel"),
      email: document.getElementById("contactConfirmEmail"),
      startDate: document.getElementById("contactConfirmStartDate"),
    };

    const postNameJa = document.getElementById("postNameJa");
    const postDetail = document.getElementById("postDetail");
    const postTel = document.getElementById("postTel");
    const postEmail = document.getElementById("postEmail");
    const postStartDate = document.getElementById("postStartDate");
    const postPropertyType = document.getElementById("postPropertyType");
    const postMansionType = document.getElementById("postMansionType");
    const postResidenceType = document.getElementById("postResidenceType");
    const postPostcode = document.getElementById("postPostcode");

    const telError = document.getElementById("contact-tel-error");
    const postcodeError = document.getElementById("contact-postcode-error");

    /** 数字以外（ハイフン・空白・全角等）を除去 */
    function normalizePhoneNumber(input) {
      return (input || "").replace(/[^\d]/g, "");
    }

    /** 日本の電話番号（携帯・IP電話／固定電話）として妥当かを判定 */
    function isValidJapanesePhoneNumber(input) {
      const tel = normalizePhoneNumber(input);
      // 携帯・IP電話
      if (/^(050|060|070|080|090)\d{8}$/.test(tel)) {
        return true;
      }
      // 固定電話ざっくり判定：0始まり10桁
      if (/^0\d{9}$/.test(tel)) {
        return true;
      }
      return false;
    }

    /** 電話番号のエラーメッセージ（空文字なら問題なし） */
    function getTelErrorMessage(rawValue) {
      const value = (rawValue || "").trim();
      if (value === "") {
        return "電話番号を入力してください";
      }
      // ハイフン類（半角・全角・各種ダッシュ）が含まれる場合
      if (/[-‐‑‒–—―−ー－]/.test(value)) {
        return "ハイフンを省いて電話番号を入力してください";
      }
      if (!isValidJapanesePhoneNumber(value)) {
        return "正しい電話番号を入力してください";
      }
      return "";
    }

    function showTelError(message) {
      if (telError) {
        telError.textContent = message;
      }
      if (el.tel) {
        el.tel.classList.toggle("invalid", message !== "");
      }
    }

    function normalizePostcode(input) {
      const digits = String(input || "")
        .replace(/[０-９]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 65248))
        .replace(/\D/g, "")
        .slice(0, 7);
      return digits.length > 3 ? `${digits.slice(0, 3)}-${digits.slice(3)}` : digits;
    }

    function validatePostcode() {
      const postcode = normalizePostcode(el.postcode?.value || "");
      if (el.postcode) {
        el.postcode.value = postcode;
        el.postcode.setCustomValidity(
          /^\d{3}-\d{4}$/.test(postcode) ? "" : "郵便番号は123-4567の形式で入力してください"
        );
      }
      if (postcodeError) {
        postcodeError.textContent =
          postcode && !/^\d{3}-\d{4}$/.test(postcode)
            ? "郵便番号は123-4567の形式で入力してください"
            : "";
      }
      return /^\d{3}-\d{4}$/.test(postcode);
    }

    function validateTel() {
      const message = getTelErrorMessage(el.tel ? el.tel.value : "");
      showTelError(message);
      return message === "";
    }

    function updateMansionTypeVisibility() {
      const isMansion = el.residenceType?.value === "マンション";
      if (el.mansionTypeRow) el.mansionTypeRow.hidden = !isMansion;
      if (el.mansionType) {
        el.mansionType.required = isMansion;
        if (!isMansion) el.mansionType.value = "";
      }
    }

    function isBunjoType(value) {
      return value === "分譲" || value === "所有（分譲）" || value === "所有";
    }

    function bunjoLabel(value) {
      return isBunjoType(value) ? "分譲" : value;
    }

    function getCanonicalResidenceType(propertyType, mansionType) {
      if (propertyType === "戸建て") return "持ち家";
      if (propertyType === "不動産オーナー" || propertyType === "管理会社") {
        return propertyType;
      }
      if (propertyType === "マンション") {
        if (mansionType === "賃貸") return "分譲／賃貸";
        if (isBunjoType(mansionType)) return "分譲";
        if (mansionType === "不動産オーナー" || mansionType === "管理会社") {
          return mansionType;
        }
      }
      return "";
    }

    /** 日付入力（yyyy-mm-dd）または旧 yyyy/mm/dd を表示用「yyyy年m月d日」へ */
    function formatStartDateLabel(raw) {
      const t = (raw || "").trim();
      if (!t) {
        return "—";
      }
      let m = t.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      if (!m) {
        m = t.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})$/);
      }
      if (!m) {
        return t;
      }
      const y = Number(m[1], 10);
      const mo = Number(m[2], 10);
      const d = Number(m[3], 10);
      return `${y}年${mo}月${d}日`;
    }

    function buildDetailText(
      propertyType,
      mansionType,
      residenceType,
      postcode,
      name,
      tel,
      startLabel
    ) {
      const lines = [
        `郵便番号：${postcode || "—"}`,
        `物件種別：${propertyType || "—"}`,
        mansionType ? `マンション区分：${bunjoLabel(mansionType)}` : "",
        `住居区分：${bunjoLabel(residenceType) || "—"}`,
        `お名前：${name || "—"}`,
        `電話番号：${tel || "—"}`,
        `ガス利用開始希望日：${startLabel}`,
      ];
      return lines.filter(Boolean).join("\n");
    }

    function syncConfirmFromEntry() {
      const propertyType = el.residenceType?.value?.trim() || "";
      const mansionType = el.mansionType?.value?.trim() || "";
      const residenceType = getCanonicalResidenceType(propertyType, mansionType);
      const postcode = normalizePostcode(el.postcode?.value || "");
      const name = el.name?.value?.trim() || "";
      const tel = el.tel?.value?.trim() || "";
      const email = el.email?.value?.trim() || "";
      const startRaw = el.startDate?.value?.trim() || "";
      const startLabel = startRaw ? formatStartDateLabel(startRaw) : "—";

      if (view.name) {
        view.name.textContent = name || "—";
      }
      if (view.residenceType) {
        view.residenceType.textContent = propertyType || "—";
      }
      if (view.mansionTypeRow) {
        view.mansionTypeRow.hidden = propertyType !== "マンション";
      }
      if (view.mansionType) {
        view.mansionType.textContent = bunjoLabel(mansionType) || "—";
      }
      if (view.postcode) {
        view.postcode.textContent = postcode || "—";
      }
      if (view.tel) {
        view.tel.textContent = tel || "—";
      }
      if (view.email) {
        view.email.textContent = email || "—";
      }
      if (view.startDate) {
        view.startDate.textContent = startLabel;
      }

      if (postNameJa) {
        postNameJa.value = name;
      }
      if (postDetail) {
        postDetail.value = buildDetailText(
          propertyType,
          mansionType,
          residenceType,
          postcode,
          name,
          tel,
          startLabel
        );
      }
      if (postTel) {
        postTel.value = tel;
      }
      if (postEmail) {
        postEmail.value = email;
      }
      if (postStartDate) {
        // サーバ側は任意項目。生の入力値を送る（未入力は空）
        postStartDate.value = startRaw;
      }
      if (postPropertyType) {
        postPropertyType.value = propertyType;
      }
      if (postMansionType) {
        postMansionType.value = bunjoLabel(mansionType);
      }
      if (postResidenceType) {
        postResidenceType.value = residenceType;
      }
      if (postPostcode) {
        postPostcode.value = postcode;
      }
    }

    entryForm.addEventListener("submit", (event) => {
      event.preventDefault();
      const telValid = validateTel();
      const postcodeValid = validatePostcode();
      const nativeValid = entryForm.checkValidity();
      if (!nativeValid || !telValid || !postcodeValid) {
        if (!nativeValid) {
          entryForm.reportValidity();
        } else if (!telValid && el.tel) {
          el.tel.focus();
        }
        return;
      }
      syncConfirmFromEntry();
      globalThis.showModalKeepScroll(confirmDialog);
      const sendBtn = phpForm.querySelector("#contactConfirmSendBtn");
      if (sendBtn && typeof sendBtn.focus === "function") {
        sendBtn.focus();
      }
    });

    confirmDialog.addEventListener("close", () => {
      confirmDialog.classList.remove("js-show");
    });

    document.querySelectorAll(".js-contactMailConfirm-back").forEach((btn) => {
      btn.addEventListener("click", () => {
        confirmDialog.classList.remove("js-show");
        confirmDialog.close();
      });
    });

    phpForm.addEventListener("submit", (event) => {
      const url = phpForm.getAttribute("data-php-mail-action")?.trim();
      if (!url) {
        event.preventDefault();
        window.alert(
          "送信先が未設定です。contactPhpMailForm の data-php-mail-action に mail.php のURLを設定してください。"
        );
        return;
      }
      phpForm.action = url;
    });

    const telInput = el.tel;
    if (telInput instanceof HTMLInputElement) {
      // フォーカスアウトで検証してエラーを表示
      telInput.addEventListener("blur", () => {
        validateTel();
      });
      // すでにエラー表示中のときだけ、入力に追従して再検証（修正で即クリア）
      telInput.addEventListener("input", () => {
        if (telInput.classList.contains("invalid")) {
          validateTel();
        }
      });
    }

    const postcodeInput = el.postcode;
    if (postcodeInput instanceof HTMLInputElement) {
      postcodeInput.addEventListener("input", () => {
        postcodeInput.value = normalizePostcode(postcodeInput.value);
        postcodeInput.setCustomValidity("");
        if (postcodeError) postcodeError.textContent = "";
      });
      postcodeInput.addEventListener("blur", validatePostcode);
    }

    if (el.residenceType) {
      el.residenceType.addEventListener("change", updateMansionTypeVisibility);
    }
    updateMansionTypeVisibility();

  }
}
